import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {BpgCommonService} from '../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../bpg-common/models/bpg-constants';

@Injectable({
  providedIn: 'root'
})
export class DiHomePageService {

  constructor(private readonly http:HttpClient,
    private readonly bpgCommonService:BpgCommonService ) { }

    URI : string = ConstantValues.userManagementApiUrl.userManagementUrl;
    diNewsListApi:  string = ConstantValues.userManagementApiUrl.getDiNewsList;
    reteamListApi:  string = ConstantValues.userManagementApiUrl.getReteamList;
    naacListApi:  string = ConstantValues.userManagementApiUrl.getNaacList;
    diMasterListApi :string = ConstantValues.userManagementApiUrl.getDiMasterList;
    getDiResouceListApi : string = ConstantValues.userManagementApiUrl.getDiResouceList;


  /** For service call to get bpg news list
   * @class DiHomePageService
   * @method getDiNewsList
   * @param landingData
   * @returns Observable
   **/

 getDiNewsList(landingData: any): Observable<any> {
  return this.http.post(this.URI+this.diNewsListApi,landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;
    }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}


 /** For service call to get bpg news list
   * @class DiHomePageService
   * @method getEngagementTeamList
   * @param landingData
   * @returns Observable
   **/
 getEngagementTeamList(landingData: any): Observable<any> {
  return this.http.post(this.URI+this.reteamListApi,landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;
    }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}


 /** For service call to get bpg news list
   * @class DiHomePageService
   * @method getNaacList
   * @param landingData
   * @returns Observable
   **/
public getNaacList(landingData: any): Observable<any> {
  return this.http.post(this.URI+this.naacListApi,landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;
    }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}

/** For service call to get  di master List
   * @class DiHomePageService
   * @method getDiMasterList
   * @param landingData
   * @returns Observable
   **/
  public getDiMasterList(landingData): Observable<any> {
    
    return this.http.post(this.URI+this.diMasterListApi,landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

      })) .pipe(catchError((error: any) => {
          throw of(error);
      }))
    }


    /** For service call to get bpg di resource List
   * @class DiHomePageService
   * @method getDiResouceList
   * @param landingData
   * @returns Observable
   **/
  public getDiResouceList(landingData): Observable<any> {
    return this.http.post(this.URI+this.getDiResouceListApi,landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

      })) .pipe(catchError((error: any) => {
          throw of(error);
      }))

  }


}
